import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggregatedIncidentsCarResponse } from '@/api/routes/incidents/types';

import { fetchIncidentsAggregateCar } from './actionCreators';

interface InitialState {
  aggregatedIncidentsCar: AggregatedIncidentsCarResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggregatedIncidentsCar: {},
  isLoading: false,
  error: '',
};

export const aggregatedIncidentsCarSlice = createSlice({
  name: 'aggregatedIncidentsCar',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchIncidentsAggregateCar.fulfilled.type]: (state, action: PayloadAction<AggregatedIncidentsCarResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.aggregatedIncidentsCar = action.payload;
    },
    [fetchIncidentsAggregateCar.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchIncidentsAggregateCar.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggregatedIncidentsCarSlice.reducer;
